// ===================================================================
// 站点数据（前端演示数据，可后续替换为后端接口）
// ===================================================================

export const site = {
  name: '职业选手苏屠',
  fullName: '职业选手苏屠 · 回馈新老粉丝福利',
  slogan: '每天动动手指，轻松赚 10 - 20 元',
  desc:
    '苏屠粉丝专属福利站：商单任务、密钥任务、微信签到打卡任务持续上新，任务简单、结算透明，做完即可提现。',
  stats: [
    { label: '累计发放福利', value: '128.6', unit: '万元' },
    { label: '在线粉丝', value: '36,942', unit: '人' },
    { label: '平均日收益', value: '10 - 20', unit: '元' },
    { label: '任务通过率', value: '98.6', unit: '%' },
  ],
}

// 任务分类
export const categories = [
  {
    key: 'shangdan',
    name: '商单任务',
    en: 'SHANG DAN',
    emoji: '🧾',
    badge: '单价最高',
    short: '品牌推广商单，按单结算',
    desc: '对接品牌方推广商单，完成转发、点赞、截图、下载注册等动作即可拿钱，单价高、上手快。',
    dailyEarn: '8 - 12',
    accent: '#ff9e2c',
    tasks: [
        {
        id: 'sd4',
        title: '抖音视频点赞 + 走心评论',
        reward: 2.5,
        minutes: 4,
        quota: 500,
        left: 213,
        difficulty: '简单',
        tags: ['点赞', '评论', '需20字以上'],
      },

      {
        id: 'sd2',
        title: '应用商店下载注册并登录',
        reward: 3.5,
        minutes: 6,
        quota: 260,
        left: 47,
        difficulty: '简单',
        tags: ['下载', '注册', '需保留3天'],
      },
      {
        id: 'sd3',
        title: '朋友圈转发商单海报（保留 2 小时）',
        reward: 3.0,
        minutes: 5,
        quota: 300,
        left: 96,
        difficulty: '简单',
        tags: ['转发', '截图', '保留2小时'],
      },

      {
        id: 'sd5',
        title: '商品好评 + 晒图 3 张',
        reward: 4.0,
        minutes: 8,
        quota: 180,
        left: 22,
        difficulty: '中等',
        tags: ['好评', '晒图', '真实体验'],
      },
      {
        id: 'sd6',
        title: '视频号点赞 + 转发',
        reward: 2.0,
        minutes: 3,
        quota: 450,
        left: 176,
        difficulty: '简单',
        tags: ['点赞', '转发', '截图'],
      },
      {
        id: 'sd7',
        title: '小红书笔记收藏 + 评论',
        reward: 2.2,
        minutes: 4,
        quota: 380,
        left: 91,
        difficulty: '简单',
        tags: ['收藏', '评论', '需15字以上'],
      },
      {
        id: 'sd8',
        title: '小程序体验并评分 5 星',
        reward: 3.0,
        minutes: 6,
        quota: 240,
        left: 63,
        difficulty: '简单',
        tags: ['体验', '评分', '截图'],
      },
      {
        id: 'sd9',
        title: '电商店铺收藏 + 加购物车',
        reward: 1.8,
        minutes: 3,
        quota: 600,
        left: 245,
        difficulty: '简单',
        tags: ['收藏', '加购', '截图'],
      },
      {
        id: 'sd10',
        title: '品牌深度种草图文（发布并保留 7 天）',
        reward: 8.0,
        minutes: 20,
        quota: 60,
        left: 14,
        difficulty: '中等',
        tags: ['原创图文', '保留7天', '审核较严'],
      },
    ],
  },
  {
    key: 'key',
    name: '苏屠密钥任务',
    en: 'SU TU KEY',
    emoji: '🔑',
    badge: '粉丝专属',
    short: '看直播领密钥，做任务领福利',
    desc: '苏屠直播间专属密钥任务：看直播、发弹幕、邀请助力，用密钥解锁专属福利，苏屠粉丝专属通道。',
    dailyEarn: '6 - 10',
    accent: '#ff4d4d',
    tasks: [
      {
        id: 'ky1',
        title: '观看苏屠直播满 15 分钟领密钥',
        reward: 2.0,
        minutes: 15,
        quota: 999,
        left: 356,
        difficulty: '简单',
        tags: ['看直播', '时长截图'],
      },
      {
        id: 'ky2',
        title: '激活苏屠专属密钥并截图',
        reward: 3.0,
        minutes: 5,
        quota: 500,
        left: 118,
        difficulty: '简单',
        tags: ['激活', '截图上传'],
      },
      {
        id: 'ky3',
        title: '密钥邀请 1 位好友助力',
        reward: 1.5,
        minutes: 3,
        quota: 800,
        left: 402,
        difficulty: '简单',
        tags: ['邀请', '助力成功'],
      },
      {
        id: 'ky4',
        title: '直播间发送指定弹幕 3 条',
        reward: 1.5,
        minutes: 4,
        quota: 999,
        left: 521,
        difficulty: '简单',
        tags: ['弹幕', '截图'],
      },
      {
        id: 'ky5',
        title: '参与密钥抽奖并分享结果',
        reward: 2.5,
        minutes: 5,
        quota: 400,
        left: 74,
        difficulty: '简单',
        tags: ['抽奖', '分享'],
      },
      {
        id: 'ky6',
        title: '密钥分享到 3 个粉丝群',
        reward: 2.0,
        minutes: 5,
        quota: 600,
        left: 163,
        difficulty: '简单',
        tags: ['分享', '3个群', '截图'],
      },
      {
        id: 'ky7',
        title: '观看直播回放并截图弹幕',
        reward: 1.8,
        minutes: 12,
        quota: 700,
        left: 289,
        difficulty: '简单',
        tags: ['看回放', '截图'],
      },
      {
        id: 'ky8',
        title: '填写苏屠粉丝专属问卷',
        reward: 2.8,
        minutes: 6,
        quota: 350,
        left: 57,
        difficulty: '简单',
        tags: ['问卷', '认真填写'],
      },
    ],
  },
  {
    key: 'wechat',
    name: '微信签到打卡任务',
    en: 'WECHAT CHECK-IN',
    emoji: '📅',
    badge: '每天可做',
    short: '签到、打卡、转发，天天有收益',
    desc: '微信生态轻量任务：小程序签到、朋友圈打卡、群内转发、公众号互动，每天可做，坚持有额外奖励。',
    dailyEarn: '5 - 9',
    accent: '#4ecb7a',
    tasks: [
      {
        id: 'wc1',
        title: '每日微信小程序签到',
        reward: 0.8,
        minutes: 1,
        quota: 9999,
        left: 6000,
        difficulty: '极简',
        tags: ['签到', '每日一次'],
      },
      {
        id: 'wc2',
        title: '朋友圈打卡并截图',
        reward: 1.5,
        minutes: 3,
        quota: 999,
        left: 640,
        difficulty: '简单',
        tags: ['打卡', '截图'],
      },
      {
        id: 'wc3',
        title: '微信群转发海报（3 个群）',
        reward: 2.0,
        minutes: 5,
        quota: 600,
        left: 155,
        difficulty: '简单',
        tags: ['转发', '3个群', '截图'],
      },
      {
        id: 'wc4',
        title: '公众号文章点赞 + 在看',
        reward: 1.0,
        minutes: 2,
        quota: 999,
        left: 733,
        difficulty: '极简',
        tags: ['点赞', '在看'],
      },
      {
        id: 'wc5',
        title: '连续打卡 3 天额外奖励',
        reward: 3.0,
        minutes: 1,
        quota: 9999,
        left: 9999,
        difficulty: '简单',
        tags: ['连续3天', '自动发放'],
      },
      {
        id: 'wc6',
        title: '微信运动步数打卡（满 6000 步）',
        reward: 1.2,
        minutes: 1,
        quota: 9999,
        left: 8200,
        difficulty: '极简',
        tags: ['步数', '截图'],
      },
      {
        id: 'wc7',
        title: '视频号点赞 + 转发好友',
        reward: 1.5,
        minutes: 3,
        quota: 800,
        left: 344,
        difficulty: '简单',
        tags: ['点赞', '转发'],
      },
      {
        id: 'wc8',
        title: '连续打卡 7 天大奖',
        reward: 6.0,
        minutes: 1,
        quota: 9999,
        left: 9999,
        difficulty: '中等',
        tags: ['连续7天', '高奖励'],
      },
    ],
  },
]

// 其它挣米业务（陆续更新）
export const upcoming = [
  { name: '短视频带货分佣', note: '正在洽谈供应商，即将上线', eta: '即将上线' },
  { name: '游戏代练 / 陪玩接单', note: '苏屠粉丝专属接单通道', eta: '即将上线' },
  { name: '直播间互动任务', note: '点赞、涨粉、互动任务池', eta: '测试中' },
  { name: '粉丝专属抽奖分佣', note: '参与抽奖还能分佣', eta: '规划中' },
  { name: '内容二创激励', note: '二创视频按播放量结算', eta: '规划中' },
]

// 参与流程
export const steps = [
  { n: '01', title: '选任务', desc: '在首页挑选适合自己的赚米任务分类' },
  { n: '02', title: '领取任务', desc: '点“立即领取”，按页面要求完成任务动作' },
  { n: '03', title: '提交截图', desc: '上传完成截图 / 编写内容，一键提交' },
  { n: '04', title: '审核到账', desc: '审核通过（一般 5 分钟）收益直入余额，随时提现' },
]

// 粉丝晒单
export const testimonials = [
  { name: '粉丝·阿凯', text: '下班做了 5 个商单，当天到账 14 块，提现秒到，靠谱。', earn: '14.0' },
  { name: '粉丝·小柔', text: '微信打卡天天做，早上花两分钟签到，一个月攒了顿火锅钱。', earn: '10.8' },
  { name: '粉丝·老表', text: '商单任务最适合我，写几条评论、截个图就十几块，多劳多得。', earn: '18.5' },
  { name: '粉丝·大聪', text: '密钥任务简单，看苏屠直播顺便就把任务做了，双倍快乐。', earn: '12.0' },
]

// 常见问题
export const faqs = [
  {
    q: '做任务一天真的能赚 10 - 20 元吗？',
    a: '单个任务奖励在 0.8 - 8 元之间。多数粉丝每天完成 3 - 6 个任务，收益普遍在 10 - 20 元区间；多做单价高的商单任务，可超过 20 元。收益因投入时间而异。',
  },
  {
    q: '收益怎么结算？多久到账？',
    a: '任务审核通过后（一般 5 分钟）收益自动计入余额，支持当日提现。活动福利由苏屠团队统一发放。',
  },
  {
    q: '任务难不难？新人能做吗？',
    a: '绝大多数是点赞、转发、签到、写评论这类简单任务，手机上几分钟就能完成，新人当天即可上手。',
  },
  {
    q: '需要交钱或提供账号密码吗？',
    a: '本站所有任务免费参与，绝不会索要你的账号密码或任何费用。遇到收费要求请立即停止并举报。',
  },
]
